import React from "react";
import { Group, Text, ThemeIcon, UnstyledButton } from "@mantine/core";

/**
 * Clickable row with icon + label. Uses ThemeIcon (not ActionIcon) so it can sit inside UnstyledButton.
 */
const FormInlineActionLink = ({
  onClick,
  disabled,
  icon: Icon,
  label,
  children,
  spacing = "xs",
  iconOverride,
}) => (
  <UnstyledButton onClick={onClick} disabled={disabled}>
    <Group spacing={spacing}>
      {iconOverride ?? (
        <ThemeIcon variant="light" size="sm" radius="xl">
          <Icon size="1rem" />
        </ThemeIcon>
      )}
      {label != null ? <Text size="xs">{label}</Text> : null}
      {children}
    </Group>
  </UnstyledButton>
);

export { FormInlineActionLink };
export default FormInlineActionLink;
